query Reference2Codes($Ref2CodeFilter: Reference2CodeFilter) {
  reference2Codes(orderBy: REFERENCE_CODE_ASC, filter: $Ref2CodeFilter) {
    nodes {
      name
      referenceCode
    }
  }
}
